import { render, staticRenderFns } from "./ChatWindow.vue?vue&type=template&id=3af19f98"
import script from "./ChatWindow.vue?vue&type=script&lang=js"
export * from "./ChatWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af19f98')) {
      api.createRecord('3af19f98', component.options)
    } else {
      api.reload('3af19f98', component.options)
    }
    module.hot.accept("./ChatWindow.vue?vue&type=template&id=3af19f98", function () {
      api.rerender('3af19f98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChatWindow.vue"
export default component.exports